import {
  CreateTutorialJourneyCommand,
  TutorialJourneyDto,
} from "@growth-machine-llc/stridist-api-client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import TutorialJourneysService from "../../../services/TutorialJourneysService";
import { TUTORIAL_JOURNEYS_QUERY_KEY } from "../journey/TutorialJourneysList";

export function useCreateTutorialJourney() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: TutorialJourneysService.createTutorialJourney,
    onSuccess: (data, variables) => {
      queryClient.setQueryData(
        [TUTORIAL_JOURNEYS_QUERY_KEY],
        (oldData: TutorialJourneyDto[] = []) => {
          const newTutorialJourney = TutorialJourneyDto.fromJS({
            ...variables,
            id: data,
          });
          return [newTutorialJourney, ...oldData];
        },
      );
      queryClient.invalidateQueries({
        queryKey: [TUTORIAL_JOURNEYS_QUERY_KEY],
      });
    },
  });
}
